import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/header.css";
import "./styles/cardscurso.css";
import "./styles/antedepois1.css";
import "./styles/antesdepois2.css";
import "./styles/resultados.css";
import "./styles/sobredois.css";
import "./styles/footer.css";

import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
  return (
    <>
      <section className="landing_section">
        <div className="container">
          <div className="row align-items-center h-100">
            <div className="col-lg-6 col-md-12 text-section">
              <div className="logo-title d-flex align-items-center mb-3">
                <img
                  src="/logo_manu.png"
                  alt="Logo"
                  className="me-2 logo-guidalli"
                />
                <div>
                  <h2 className="emanuelle-title">Emanuelle Maia</h2>
                  <p className="emanuelle-sub">
                    Expert em HiPro • Estética Avançada & Tecnologias de Alta
                    Performance
                  </p>
                </div>
              </div>

              <h1 className="main-title">
                Treinamento em Remodelação Corporal com{" "}
                <span className="highlight-orange">Scizer</span> e{" "}
                <span className="highlight-orange">Hipro</span>
              </h1>

              <p className="description mt-4">
                Domine as tecnologias <strong>Scizer</strong> e{" "}
                <strong>Hipro</strong> para resultados de Alta Performance com{" "}
                <strong>
                  Certificação Internacional Americana Guidalli International
                </strong>
                .
              </p>
              <p className="description">
                Neste treinamento,{" "}
                <strong>contarei os segredos clínicos</strong>, os protocolos
                validados e as estratégias que me tornaram uma{" "}
                <strong>profissional de sucesso</strong>. Prepare-se para uma
                experiência de aprendizado intensa, prática e transformadora,
                que{" "}
                <strong>
                  irá levar seus resultados e sua carreira para o próximo nível
                </strong>
                .
              </p>

              <button className="btn-curso mt-4">
                Conheça mais sobre o curso <span className="arrow">↓</span>
              </button>
            </div>
            <div className="col-lg-6 col-md-12 text-center mt-4 mt-lg-0 image-section d-lg-none">
              <img
                src="/manu_sombra.png"
                alt="Emanuelle Maia"
                className="img-fluid emanuelle-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section_img_repeat">
        <div className="logo-slider">
          <div className="slide-track">
            {[...Array(20)].map((_, i) => (
              <div className="slide" key={i}>
                <img src="/logo_guidalli.png" alt="Logo Guidalli" />
              </div>
            ))}
            {[...Array(20)].map((_, i) => (
              <div className="slide" key={`dup-${i}`}>
                <img src="/logo_guidalli.png" alt="Logo Guidalli" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section_cards_curso d-flex justify-content-center align-items-center">
        <div className="container card_curso_container">
          <h2 className="curso_title text-center mb-5">
            Por que você deveria fazer este curso?
          </h2>

          <div className="row justify-content-center">
            {/* Card 1 */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="curso_card h-100">
                <div className="icon_box_custom mb-3">
                  <i className="bi bi-patch-check"></i>
                </div>
                <h5 className="card_title">
                  Domine as tecnologias mais desejadas do mercado!
                </h5>
                <p className="card_text">
                  Aprenda a manusear com maestria os equipamentos{" "}
                  <strong>Scizer</strong> e <strong>Hipro</strong>, elas são as{" "}
                  <strong>ferramentas mais eficazes</strong> para combate à
                  gordura localizada e flacidez. Você irá entregar resultados
                  visíveis desde as primeiras sessões,
                  <strong>
                    {" "}
                    elevando a satisfação e fidelidade dos seus clientes
                  </strong>{" "}
                  a um novo patamar.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="curso_card h-100">
                <div className="icon_box_custom mb-3">
                  <i className="bi bi-patch-check"></i>
                </div>
                <h5 className="card_title">
                  Posicione-se como autoridade e aumente seu faturamento!
                </h5>
                <p className="card_text">
                  Ofereça <strong>protocolos premium e exclusivos</strong> com
                  estimativa de faturamento de até{" "}
                  <strong>20 mil por dia</strong>. Ao se especializar em
                  tratamentos de alto valor agregado, você{" "}
                  <strong>atrai um público mais exigente</strong>, permitindo
                  praticar preços mais elevados e obter{" "}
                  <strong>
                    retorno sobre o investimento rápido e consistente
                  </strong>
                  .
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-4 col-md-12 mb-4">
              <div className="curso_card h-100">
                <div className="icon_box_custom mb-3">
                  <i className="bi bi-patch-check"></i>
                </div>
                <h5 className="card_title">
                  Conquiste uma Certificação de Prestígio Internacional!
                </h5>
                <p className="card_text">
                  Você sairá com a{" "}
                  <strong>Certificação Guidalli International</strong>,
                  reconhecida mundialmente. Ministrado pela{" "}
                  <strong>Dra. Emanuelle Maia</strong>, este título confere
                  credibilidade imediata, gera confiança nos clientes e{" "}
                  <strong>abre portas para novas oportunidades</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section_antesdepois">
        <div className="container">
          <div className="row align-items-center">
            {/* Coluna de Texto */}
            <div className="col-lg-6 col-md-12">
              <h2 className="antesdepois_title">
                Hipro: <span>Lifting e Firmeza para a Face e Corpo</span>
              </h2>
              <p className="antesdepois_text">
                Domine a tecnologia de{" "}
                <strong>ultrassom micro e macro focado</strong> de alta
                intensidade que trata a flacidez e a gordura em áreas delicadas
                e estratégicas.
              </p>
              <p className="antesdepois_text">
                O <strong>Hipro</strong> é a sua ferramenta ideal para promover
                um <strong>efeito lifting imediato</strong>, rejuvenescer a pele
                e alcançar resultados de alta definição onde seus clientes mais
                desejam.
              </p>
              <h4 className="antesdepois_subtitle">Áreas de Tratamento:</h4>
              <ul className="antesdepois_list">
                <li>Lifting de face completa</li>
                <li>Redução de papada e flacidez de pescoço</li>
                <li>Flacidez abdominal e braços</li>
                <li>Flacidez da parte interna das coxas</li>
                <li>Rejuvenescimento das mãos</li>
                <li>
                  Único equipamento que{" "}
                  <strong>promove efeito de Lipo HD</strong>
                </li>
              </ul>
              <button className="btn-antesdepois">
                Protocolos Exclusivos e Validados
              </button>
            </div>

            {/* Coluna das Imagens */}
            <div className="col-lg-6 col-md-12 text-center d-flex align-items-center justify-content-center  mt-4">
              <div className="maquina_img">
                <img
                  src="/maquina_hipro.png"
                  alt="Hipro"
                  className="img-fluid"
                />
              </div>
              <div className="antesdepois_img">
                <img
                  src="/teste2.png"
                  alt="Resultados Antes e Depois"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section_img_repeat_2">
        <div className="logo-slider">
          <div className="slide-track">
            {[...Array(20)].map((_, i) => (
              <div className="slide" key={i}>
                <img src="/logo_guidalli.png" alt="Logo Guidalli" />
              </div>
            ))}
            {[...Array(20)].map((_, i) => (
              <div className="slide" key={`dup-${i}`}>
                <img src="/logo_guidalli.png" alt="Logo Guidalli" />
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="section_antesdepoisdois d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center h-100">
            {/* Coluna das Imagens */}
            <div className="col-lg-3 col-md-12 d-flex flex-column align-items-center justify-content-center antesdepois-col">
              <img
                src="/antesdepois2.png"
                alt="Antes e Depois 2"
                className="img-fluid antesdepois-frame"
              />
            </div>

            {/* Coluna Máquina */}
            <div className="col-lg-4 col-md-12 text-center maquina-col">
              <img
                src="/maquinadois.png"
                alt="Scizer"
                className="img-fluid maquina-img"
              />
            </div>

            {/* Coluna Texto */}
            <div className="col-lg-5 col-md-12 texto-col">
              <h2 className="antesdepois2_title">
                <span className="highlight-scizer">Scizer:</span> Único
                equipamento capaz de realizar lipo sem cortes e remodelação
                corporal com eficácia!
              </h2>
              <p className="antesdepois2_text">
                Domine a tecnologia de <strong>ultrassom macrofocado</strong>{" "}
                projetada para a destruição definitiva da gordura localizada e
                remodelação de grandes áreas corporais.
              </p>
              <h4 className="antesdepois2_subtitle">Áreas de Tratamento:</h4>
              <ul className="antesdepois2_list">
                <li>Abdômen completo e flancos</li>
                <li>Costas e gordura do sutiã</li>
                <li>Culotes e posterior de coxa</li>
                <li>Braços e interno de coxa</li>
              </ul>
              <button className="btn-antesdepois2">
                <i className="bi bi-star-fill me-2"></i>
                Metodologia 100% Hands On
                <i className="bi bi-star-fill ms-2"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="section_resultadoscomprovam">
        <div className="frame_superior_fixo">
          <div
            style={{
              borderRadius: "0 0 20px 20px",
            }}
          />
        </div>

        <div className="resultados_content">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <h2 className="resultados_title">
                  Resultados que Comprovam a <br />
                  Eficácia do Método
                </h2>
                <p className="resultados_subtitle">
                  Confiança se constrói com resultados, e é isso que nosso
                  método entrega. Com uma vasta casuística de pacientes,
                  desenvolvemos protocolos seguros que foram testados e
                  aprovados na prática. Você recebe um roteiro de sucesso
                  validado, pronto para ser aplicado na sua clínica com a
                  certeza de oferecer uma técnica eficaz e de alto padrão.
                </p>
              </div>
            </div>

            <div className="row justify-content-center align-items-center resultados_images_row">
              <div className="resultado_frame">
                <img
                  src="/testeframe.png"
                  alt="Antes e Depois Scizer"
                  className="img-fluid-1"
                />
              </div>
            </div>

            {/* Frame Inferior */}
          </div>
        </div>
        <div className="frame_inferior_fixo">
          <div
            style={{
              borderRadius: "20px 20px 0 0",
            }}
          />
        </div>
      </section>
      <section className="section_sobre_dois">
        <div className="container">
          <div className="row align-items-center mb-5">
            {/* Coluna da Imagem Esquerda */}
            <div className="col-lg-5 col-md-12 mb-4 mb-lg-0 text-center">
              <img
                src="./manu_frente.png"
                alt="Profissional"
                className="sobre-img"
              />
            </div>
            {/* Coluna do Texto Direita */}
            <div className="col-lg-7 col-md-12">
              <h2 className="sobre_title">
                Escolha a estrutura ideal <br /> para seus objetivos!
              </h2>
              <p className="sobre_text">
                Entendemos que cada profissional possui necessidades e momentos
                de carreira diferentes. Por isso, estruturamos nosso treinamento
                em dois formatos para que você possa escolher o que melhor se
                encaixa no seu perfil e ambições!
              </p>
            </div>
          </div>

          <div className="row align-items-center">
            {/* Texto Esquerda */}
            <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">
              <h2 className="sobre_title">
                Uma Imersão de Alto Nível <br /> em um Ambiente Exclusivo!
              </h2>
              <p className="sobre_text">
                Para proporcionar a você uma experiência de aprendizado
                verdadeiramente diferenciada, nosso curso será realizado em uma
                clínica de alto padrão, cuidadosamente selecionada no coração de
                São Paulo - SP.
              </p>
            </div>
            {/* Imagem Direita */}
            <div className="col-lg-5 col-md-12 text-center">
              <img
                src="/clinica.png"
                alt="Ambiente Exclusivo"
                className="img-fluid sobre-img"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="section_footer text-center py-5">
        <div className="container">
          {/* Título */}
          <h2 className="footer_title mb-3">
            Escolha a imersão ideal para o seu momento Profissional!
          </h2>
          <p className="footer_subtitle mb-5">
            <strong>Do intensivo ao completo:</strong> dois formatos de curso
            para você dominar as técnicas de remodelação corporal com Scizer e
            Hipro, com certificação internacional.
          </p>

          <div className="row justify-content-center">
            {/* Card 1 - Opção 1 */}
            <div className="col-lg-5 col-md-6 mb-4">
              <div className="footer_card h-100 p-4">
                <h5 className="card_option">
                  <i className="bi bi-lightbulb me-2"></i> Opção 1: Imersão de 1
                  Dia
                </h5>
                <h4 className="card_title mb-3">
                  Experiência Intensiva: Resultados Visíveis em Apenas 1 Dia
                </h4>

                <div className="ideal_para mb-3">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Ideal para:</strong> Profissionais que querem um
                  treinamento prático e direto ao ponto, com foco em técnicas
                  corporais específicas.
                </div>

                <div className="voce_recebe mb-3">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Você recebe:</strong>
                </div>

                <ul className="card_list text-start mt-3 mb-4">
                  <li>• Treinamento completo em Scizer e Hipro</li>
                  <li>• Aplicações práticas em pacientes reais</li>
                  <li>• Certificação Internacional Guidalli Internacional</li>
                  <li>• Apostila digital + checklist de procedimentos</li>
                  <li>• Mentoria com Manu Maia durante o dia</li>
                  <li>
                    • Você sai do curso que mais fez sentido para você,{" "}
                    <strong>Hipro ou Scizer!</strong>
                  </li>
                </ul>

                <button className="btn-investimento w-100">
                  <i className="bi bi-currency-dollar me-2"></i>
                  Investimento: R$ 3.500,00
                </button>
              </div>
            </div>

            {/* Card 2 - Opção 2 */}
            <div className="col-lg-5 col-md-6 mb-4">
              <div className="footer_card h-100 p-4 position-relative">
                {/* Barra Mais Vendida */}
                <div className="mais_vendida">
                  Mais vendida <i className="bi bi-fire ms-1"></i>
                </div>

                <h5 className="card_option">
                  <i className="bi bi-lightbulb me-2"></i> Opção 2: Imersão de 2
                  Dias
                </h5>
                <h4 className="card_title mb-3">
                  Transformação Profunda: Domine Técnicas Corporais Premium com
                  Segurança e Autoridade
                </h4>

                <div className="ideal_para mb-3">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Ideal para:</strong> Profissionais que desejam se
                  tornar referência em remodelação corporal, com aprendizado
                  completo + diferenciais exclusivos.
                </div>

                <div className="voce_conquista mb-3">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  <strong>Você conquista:</strong>
                </div>

                <ul className="card_list text-start mt-3 mb-4">
                  <li>
                    • Treinamento avançado em todos os protocolos Scizer e Hipro
                  </li>
                  <li>
                    • Aplicações em múltiplas áreas (Full Face, Papada, Lipo HD,
                    Flancos, Coxas, Abdômen...)
                  </li>
                  <li>
                    • Certificação Internacional Guidalli Internacional{" "}
                    <i className="bi bi-patch-check-fill ms-1"></i>
                  </li>
                  <li>• Acompanhamento de resultados reais (antes e depois)</li>
                  <li>• Apostila premium + suporte pós-curso</li>
                  <li>• Mentoria com Manu Maia em ambos os dias</li>
                  <li>• Acesso ao grupo fechado de alunas</li>
                  <li>• Kit do aluno</li>
                </ul>

                <button className="btn-investimento w-100">
                  <i className="bi bi-currency-dollar me-2"></i>
                  Investimento: R$ 5.000,00
                </button>
              </div>
            </div>
          </div>

          {/* Formas de pagamento */}
          <div className="pagamento_card mt-5 p-4 mx-auto">
            <p className="mb-0">
              <strong>Formas de pagamento:</strong> 20% do valor no ato da
              matrícula e o restante no cartão de crédito em{" "}
              <strong>até 12x</strong> !
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default App;
